<template>
  <div id="app">
    <vue-topprogress ref="topProgress" class="fixed pin-t pin-x"></vue-topprogress>
    <div v-if="!system || (!initialised && $route.path !== '/oauth/login')" class="min-h-screen flex items-center justify-center">
      <loader />
    </div>
    <div v-else>
      <Menu v-if="showMenu" class="font-sans" />
      <toast-notification></toast-notification>
      <main id="page-wrap">
        <network-alerts-popup />
        <Header v-if="showHeader" />
        <router-view class="p-4 lg:px-8" />
      </main>
    </div>
  </div>
</template>

<script>
import Menu from '@/components/Menu.vue'
import Header from '@/components/Header.vue'
import { mapActions, mapState } from 'vuex'
import ToastNotification from '@/components/ToastNotification'
import Loader from './components/Loader.vue'

export default {
  name: 'app',
  components: {
    Menu,
    Header,
    ToastNotification,
    Loader
  },
  data () {
    return {
      showHeader: false,
      showMenu: false
    }
  },
  async created () {
    if (this.$route.path === '/oauth/login') {
      return
    }

    await this.fetchSystem()
    let favicon = document.getElementById('favicon')
    favicon.href = this.system.favicon
    document.title = this.system.title

    await this.bootSystem()

    await this.fetchGTMTag()
  },
  methods: {
    ...mapActions([
      'fetchProfile',
      'fetchProfileV2',
      'fetchSystem',
      'bootSystem',
      'displayToastNotification',
      'setPageLoading',
      'fetchGTMTag'
    ]),

    shouldDenyAccessAdminRoutes (profile) {
      if (this.$router.currentRoute.meta.adminOnly && profile.type > 2) {
        this.$router.push({ name: 'home' })

        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-lock',
          title: 'Unauthorized',
          info: 'You do not have permission to view that page'
        })
      }
    },

    showHideMenu (val) {
      if (val === 'login' || val === 'forgot-password' || val === 'reset-password' || val === 'easy-property-sso') {
        this.showMenu = false
        this.showHeader = false
        if (document.querySelector('#page-wrap')) {
          document.querySelector('#page-wrap').style.marginLeft = '0px'
        }
      } else {
        this.showMenu = true
        this.showHeader = true
      }
    }
  },
  computed: {
    ...mapState(['pageLoading', 'system', 'profile', 'initialised'])
    // showMenu () {
    //   console.log(this.$router.currentRoute.name)
    //   return this.$router.currentRoute.name !== 'login' &&
    //     this.$router.currentRoute.name !== 'forgot-password'
    // }
  },
  watch: {
    '$route.name' (val) {
      this.showHideMenu(val)
    },
    pageLoading (loading) {
      if (!this.initialised) {
        this.$refs.topProgress.start()
      } else {
        this.$refs.topProgress.done()
      }
    },
    '$route.path': {
      handler () {
        if (window.gtag) {
          if (this.profile) {
            window.gtag('config', this.system.gtm_tag, {
              user_id: this.profile.id
            })
          }
          window.gtag('event', 'page_view', {
            page_title: document.title,
            page_location: window.location.href
          })
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.$router.beforeEach((to, from, next) => {
      this.$store.dispatch('setPageLoading', true)
      next()
    })

    this.$router.afterEach((to, from) => {
      this.$store.dispatch('setPageLoading', false)
    })

    this.showHideMenu(this.$router.currentRoute.name)
  }
}
</script>

<style lang="scss">
.ribbon {
  @apply fixed z-30 w-64 h-8 uppercase font-medium tracking-wide shadow text-sm;
  bottom: 1rem;
  left: -6rem;
  transform: rotate(45deg);
}
@screen md {
  .ribbon {
    @apply fixed z-30 w-64 h-10 uppercase font-medium tracking-wide shadow;
    top: 2rem;
    left: -5rem;
    transform: rotate(-45deg);
  }
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.mx-datepicker {
  font: inherit !important;
  .mx-input-append {
    background-color: #f4f4f6;
  }
}

input[type="checkbox"], input[type="radio"] {
  display: none;

  +label {
      cursor: pointer;
      white-space: nowrap;
      display: inline-block;
      position: relative;
      line-height: 1rem;

      &::before {
        font-weight: 900;
        font-family: "Font Awesome 5 Free";
        text-align: center;
        content: '\00A0';
        display: inline-block;
        width: 1.25rem;
        height: 1.25rem;
        margin-right: .5em;
        border: 1px solid #dae1e7;
        position: relative;
        padding: 1px;
        font-size: .75rem;
        background: white;
      }

      &::after {
        display: none;
      }

      &:hover {
        color: #000;
      }
  }

  &:checked {
    +label {
      &::before {
        content: "\f00c";
        border-width: 1px;
        border-style: solid;
        color: #FFF;
      }

      &::after {
        content: ' ';
        display: block;
        width: 0px;
        height: 1.25em;
        z-index: 1;
        position: absolute;
        top: 0px;
        left: 1.25em;
        animation: reveal .3s ease-in;
      }
    }
  }

  &.green:checked {
    +label {
      &::before, &::after {
        background-color: #51b62c;
        border-color: #51b62c;
      }
    }
  }

  &:disabled {
    +label {
      cursor: default;
      &::before, &::after {
        background-color: #dae1e7;
        border-color: #dae1e7;
      }
    }
  }
}

@keyframes reveal {
  from {
    width: 1.25em;
    left: 0px;
  }
  to {
    width: 0px;
    left: 1.25em;
  }
}

.pagination{
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: .25rem;
  font-size: 0.75em;
  width: 100%;
  align-items: center;
  justify-content: center;
}
.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: .25rem;
  border-bottom-left-radius: .25rem;
}
.page-link {
  position: relative;
  display: block;
  padding: .2rem .2rem;
  margin-left: -1px;
  text-decoration: none;
  color: #3d4852;
}
.page-item.active .page-link {
  z-index: 1;
  color: #008BC2;
  text-decoration: underline;
  font-weight: bold;
}
.item-middle {
  height: 100%;
  margin: 0 auto;
}
</style>
